import {translations} from 'presentation/translations-new';
import {useContractStatus} from 'presentation/hooks';
import {RefundEnum} from 'presentation/constants';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {useAccountInformation} from '../../../hooks';
import {IRefundServiceList} from './types';

const {request, consult, requestPreview, consultRequestPreview, sendAdditionalDocuments} =
	translations['pt-br'].privateFlow.refund.home.refundCards;

export const useRefundList = () => {
	const {isHolder} = useAccountInformation();
	const {isValid, isCancelledAtOneYear} = useContractStatus();

	const REFUND_LIST: IRefundServiceList[] = [
		{
			title: request,
			icon: 'currency-exchange-filled',
			route: RefundEnum.TERMS,
			show: isHolder && (isValid || isCancelledAtOneYear),
			dataTagId: RefundTaggingEnum.CLICK_SOLICITAR_REEMBOLSO,
		},
		{
			title: requestPreview,
			icon: 'content-paste-filled',
			route: RefundEnum.TERMS_PREVIEW,
			show: isHolder && isValid,
			dataTagId: RefundTaggingEnum.CLICK_SOLICITAR_PREVIA_REEMBOLSO,
		},
		{
			title: consult,
			icon: 'manage-search-filled',
			route: RefundEnum.CONSULT,
			show: true,
			dataTagId: RefundTaggingEnum.CLICK_CONSULTAR_REEMBOLSO,
		},
		{
			title: consultRequestPreview,
			icon: 'content-paste-search-filled',
			route: RefundEnum.CONSULT_PREVIEW,
			show: isValid,
			dataTagId: RefundTaggingEnum.CLICK_CONSULTAR_PREVIA_REEMBOLSO,
		},
		{
			title: sendAdditionalDocuments,
			icon: 'document-scanner-filled',
			route: RefundEnum.TERMS_ADDITIONAL_DOCS,
			show: isHolder && (isValid || isCancelledAtOneYear),
			dataTagId: RefundTaggingEnum.CLICK_ENVIO_DE_DOCS_COMPLEMENTARES_REEMBOLSO,
		},
	];

	return {
		REFUND_LIST,
	};
};
